module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('b', [_vm._v("Dedication and Thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("A writer is only as good as her editor, and my history has shown this to be true. Prior to writing for AQS Publishing, I wrote Missouri travel books for Virginia Publishing and Reedy Press in St. Louis, Missouri. That was where I learned all that an editor does to make an author look good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("Writing nonfiction requires researching a subject and then writing about what’s been learned. Fact checking is necessarily a priority. That was true both with the travel books and also with the 100 Series I wrote for AQS Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("When I started writing fiction for AQS, there seemed to be a series of editors that came and went. Each one was different, but I was always pleased that they remained respectful of my story line and concentrated on grammatical corrections instead. Each had their own style of editing, but as a new fiction author, I was always grateful for their advice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("Andi Reynolds was my first editor at AQS. She and Meredith Schroeder lobbied successfully that quilt fiction needed to be a part of their offerings. They warned me that I was their guinea pig in this new venture, but my first series enjoyed immediate success. Thank you both!")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("Elaine Brelsford has been my editor for the last few series, and I can only say that she’s a gem. She knows my writing style, has good taste, and shares my success. Thank you, Elaine!")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("I don’t think editors get enough credit for all they do. I’m not saying that just because I have a son who is one, but because I know how an editor can make or break the outcome of a published piece. To all my past and present editors, I dedicate this book to you! Thank you!")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("Thanks also to the Coulson’s of The White Gull Inn for letting us show their beautiful facility on the cover of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_c('i', [_vm._v("—Ann Hazelwood")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d8408c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0002_ded.vue
// module id = 60
// module chunks = 0